<template>
	<el-dialog :close-on-click-modal="false" :close-on-press-escape="false" :show-close="false" title="评价订单" :visible.sync="dialogVisible" destroy-on-close width="800px">
		<div>
			<el-form ref="formRef" :model="form" :rules="rules" label-position="top" label-width="120px">
				<el-row :gutter="20">
					<el-col :span="10">
						<el-form-item label="商品评分：" prop="bankAccount">
							<el-rate v-model="form.rate" :colors="colors"> </el-rate>
						</el-form-item>
					</el-col>
				</el-row>

				<el-row :gutter="20">
					<el-col :span="21">
						<el-form-item label="评价内容：" prop="desc">
							<el-input type="textarea" rows="6" v-model.trim="form.desc" placeholder="请输入评价内容" />
						</el-form-item>
					</el-col>
				</el-row>
			</el-form>
		</div>
		<template #footer>
			<div class="dialog-footer">
				<el-button size="small" @click="handleClose">关闭</el-button>
				<el-button size="small" type="primary" @click="handleConfirm"> 保存 </el-button>
			</div>
		</template>
	</el-dialog>
</template>

<script>
export default {
	name: 'DialogEvaluate',
	props: {
		form: {
			type: Object,
			default: {}
		}
	},
	data() {
		return {
			dialogVisible: false,
            form: {
                id: "",
                desc: "",
                rate: 0,
            },
             colors: ['#99A9BF', '#F7BA2A', '#FF9900'] 
		};
	},
	methods: {
		handleClose() {
			this.dialogVisible = false;
			this.resetForm();
		},

		resetForm() {
			this.$refs['formRef'].resetFields();
		},

		handleConfirm() {
			this.$refs['formRef'].validate(valid => {
				if (valid) {
					this.$emit('confirmInfo', this.form);
				}
			});
		}
	}
};
</script>

<style lang="less" scoped>
// 弹出框重置样式
/deep/ .el-dialog__header {
	border-bottom: 1px dashed #e2e8f0;
	margin-right: 0;
	background: #f8fafc;
}

/deep/ .el-dialog__headerbtn .el-dialog__close {
	color: #3a434f;
	font-size: 24px;
}

/deep/ .el-dialog__footer {
	border-top: 1px solid #e8e8e8;
	padding: 18px;
}

/deep/ .el-dialog__body .el-form-item__label {
	line-height: 26px;
}
</style>
